<template>
  <request
    :download-document-by-attachment-id="downloadDocumentByAttachmentId"
    :get-compensatory-approvement-reasons="getCompensatoryApprovementReasons"
    :get-compensatory-reject-reasons="getCompensatoryRequestRejectReasons"
    :get-compensatory-request-student-service="
      getCompensatoryRequestStudentService
    "
    :get-compesatory-reposition-absence="getCompesatoryRepositionAbsence"
    :get-educational-compensatory-request="getEducationalCompensatoryRequest"
    :has-approvement-decline-panel-permissions="
      hasApprovementDeclinePanelPermissions
    "
    :has-permissions="hasPermissions"
    :has-update-due-interventions-permissions="
      hasUpdateDueInterventionsPermissions
    "
    :is-read-only="isReadOnly || isEducational"
    :reject-compensatory-request="rejectCompensatoryRequest"
    :request-service-data="serviceData"
    :save-compensatory-request="saveCompensatoryRequest"
    :submit-closing-analysis="submitClosingAnalysis"
    :update-compensatory-service-balance="updateCompensatoryServiceBalance"
    :update-due-interventions="updateDueInterventions"
    @on-click-return="onReturnHandler"
  />
</template>

<script>
import { Request } from 'compensatory-service';
import {
  submitClosingAnalysis as _submitClosingAnalysis,
  getCompesatoryRepositionAbsence as _getCompesatoryRepositionAbsence,
  getCompensatoryRequestStudentService as _getCompensatoryRequestStudentService,
  getEducationalCompensatoryRequest as _getEducationalCompensatoryRequest,
  saveCompensatoryRequest as _saveCompensatoryRequest,
  rejectCompensatoryRequest as _rejectCompensatoryRequest,
  getCompensatoryRequestRejectReasons as _getCompensatoryRequestRejectReasons,
  getCompensatoryApprovementReasons as _getCompensatoryApprovementReasons,
  updateDueInterventions as _updateDueInterventions,
  updateCompensatoryServiceBalance as _updateCompensatoryServiceBalance,
} from '@/modules/compensatoryService/api';
import peiServices from '@/modules/app/api.js';

export default {
  name: 'RequestWrapper',
  components: {
    Request,
  },
  data() {
    return {
      serviceData: null,
    };
  },
  computed: {
    isReadOnly() {
      return this.$route.params.hasCompletedRequest;
    },
    isEducational() {
      if (this.$route.query)
        return (
          this.$route.query.isEducational === true ||
          this.$route.query.isEducational === 'true'
        );

      return false;
    },
    hasApprovementDeclinePanelPermissions() {
      return this.userHasPermissions('compensatoryservice.decline.approvement');
    },
    hasUpdateDueInterventionsPermissions() {
      return this.userHasPermissions(
        'compensatoryservice.update.interventionsdue'
      );
    },
  },
  methods: {
    updateCompensatoryServiceBalance(params) {
      return _updateCompensatoryServiceBalance(params);
    },
    hasPermissions(permission) {
      return this.userHasPermissions(permission);
    },
    getCompensatoryApprovementReasons(requestId) {
      return _getCompensatoryApprovementReasons(requestId);
    },
    updateDueInterventions(requestId, visitDue) {
      return _updateDueInterventions(requestId, visitDue);
    },
    submitClosingAnalysis(id, data) {
      data.ignoreAnalysis = true;
      return _submitClosingAnalysis(id, data);
    },
    onReturnHandler(needReload) {
      if (this.$route.params.from) {
        this.$router.push({
          path: this.$route.params.from,
        });

        return;
      }

      this.$router.push({
        name: 'Main',
        params: {
          reload: needReload,
        },
      });
    },
    getCompesatoryRepositionAbsence() {
      return _getCompesatoryRepositionAbsence();
    },
    getCompensatoryRequestStudentService(requestId = 0) {
      this.serviceData = this.serviceData = this.$route.params;
      return _getCompensatoryRequestStudentService({
        requestId: requestId == 0 ? this.$route.params.requestId : requestId,
        studentServiceId: this.$route.params.studentServiceId,
      });
    },
    getEducationalCompensatoryRequest(requestId = 0) {
      this.serviceData = this.serviceData = this.$route.params;
      return _getEducationalCompensatoryRequest(
        requestId == 0 ? this.$route.params.requestId : requestId
      );
    },
    saveCompensatoryRequest(params) {
      return _saveCompensatoryRequest(params);
    },
    rejectCompensatoryRequest(params) {
      return _rejectCompensatoryRequest(params);
    },
    downloadDocumentByAttachmentId(documentId) {
      return peiServices.downloadDocumentByAttachmentId(documentId);
    },
    getCompensatoryRequestRejectReasons() {
      return _getCompensatoryRequestRejectReasons();
    },
  },
};
</script>
